//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState} from 'vuex'
export default {
    data() {
        return {
            // type: 1
        }
    },
    computed: {
        ...mapState(['isMobile']),
    },
    methods: {
        mzShoppingMall(){
            location.href = 'https://shop40787035.m.youzan.com/v2/feature/j4xKWwcf2a'
        }
        
    },
}



// WEBPACK FOOTER //
// ./src/layout/index.vue